export default __webpack_public_path__ + "static/person_1-810fcb1acee78dcdaab4472411987fd4.webp";